/// <amd-module name="Artifacts/Nuget/helpers/InstructionsHelper" />
import { IPackageVersion } from "Artifacts/Root/types";

export function getCopyInstallCommand(
  pkgName: string,
  pkgVersion: IPackageVersion,
  separator = " ",
): string {
  // Semver 2 check
  if (pkgVersion.version.indexOf("+") === -1) {
    return `Install-Package ${pkgName}${separator}-version ${pkgVersion.version}`;
  } else {
    return `Install-Package ${pkgName}${separator}-version ${pkgVersion.normalizedVersion}`;
  }
}
